import React, { useEffect, useState, useContext } from "react";
import clsx from "clsx";
//Material ui core
import { AppBar, Toolbar, Typography, IconButton } from "@material-ui/core";
//Material ui icons
import { Menu as MenuIcon } from "@material-ui/icons";
//Shared components
import DesktopView from "./DesktopView";
import MobileView from "./MobileView/MobileView";
import axios from "axios";
import { AuthContext } from "../../../Context/Auth";
import { Instance } from "../../../Context/axiosContext";
import { RestaurantContext } from "../../../Context/RestaurantData";
import { useErrorHandler } from "react-error-boundary";
import LockModal from "../LockModal";
const Header = (props) => {
  const {
    classes,
    open,
    handleDrawerOpen,
    isMobile,
    handleActivationState,
    activationStatus,
  } = props;

  const [switchValue, setSwitchValue] = useState(false);
  const [apiCounter, setApiCounter] = useState(0);
  const { user } = useContext(AuthContext);
  const axiosInstance = Instance();
  const { setRestaurantData } = useContext(RestaurantContext);
  const errorHandler = useErrorHandler();
  let apikey = localStorage.getItem("apikey");

  const getRestaurantStatus = async () => {
    if (!localStorage.getItem("apikey")) {
      window.location.reload();
    }
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_URL + `restaurant?PageName=live_orders`,
        {
          headers: {
            Authorization: user,
            ["x-api-key"]: localStorage.getItem("apikey"),
          },
        }
      );
      if (data) {
        setRestaurantData(data);
        localStorage.setItem("rest_name", data.name);
      }
    } catch (err) {
      err?.response?.data && window.alert(err?.response?.data?.error);
      localStorage.clear();
    }
  };

  const getRestStatus = async () => {
    if (apiCounter > 0) {
      window.location.reload();
      return;
    }
    // let token = getLatestToken();
    if (!localStorage.getItem("apikey")) {
      window.location.reload();
    }
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_URL + `restaurant?PageName=live_orders`,
        {
          headers: {
            Authorization: user,
            ["x-api-key"]: localStorage.getItem("apikey"),
          },
        }
      );

      if (data) {
        handleActivationState(data.activation_status);
        setRestaurantData(data);
        setSwitchValue(data.restaurant_open);
        setApiCounter(apiCounter + 1);
      }
    } catch (err) {
      err?.response?.data && window.alert(err?.response?.data?.error);
      localStorage.clear();
      window.location.reload();
    }
  };

  useEffect(() => {
    apikey && getRestStatus();
  }, [apikey]);

  const handleSwitch = () => {
    console.log("yehehe");
    setSwitchValue(!switchValue);
  };

  return (
    <AppBar
      square
      elevation={0}
      position="fixed"
      className={clsx(classes.appBar, !activationStatus && classes.mt20, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, open && classes.hide)}
        >
          <MenuIcon color="primary" />
        </IconButton>

        {!open && (
          <Typography
            variant="h4"
            noWrap
            color="primary"
            className={clsx(classes.brandStylesI, isMobile && classes.dNone)}
          >
            Insmeal
          </Typography>
        )}
        <div className={classes.spacing} />
        {/* <SearchField x={12} y={20} z={2}/> */}
        {!isMobile ? (
          <DesktopView
            classes={classes}
            switchValue={switchValue}
            setSwitchValue={setSwitchValue}
            handleSwitch={handleSwitch}
          />
        ) : (
          <MobileView
            classes={classes}
            switchValue={switchValue}
            handleSwitch={handleSwitch}
            setSwitchValue={setSwitchValue}
            getRestStatus={getRestaurantStatus}
          />
        )}
      </Toolbar>
      <LockModal getRestStatus={getRestaurantStatus} />
    </AppBar>
  );
};

export default Header;

// const getLatestToken = () => {
//   let token = null;
//   for (let i = 0; i < localStorage.length; i++) {
//     let key = localStorage.key(i);
//     let tokenKey = key.includes(".idToken") && key;
//     if (tokenKey) {
//       token = localStorage.getItem(tokenKey);
//       return token;
//     }
//   }
// };
